import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    intervalTimer: null,
    onLoadToast: null,
    user: '',
    userId: null,
    userFirstName: null,
    userLastName: null,
    userCoop: null,
    userCoopId: null,
    userInfos: null,
    dataSource: '',
    intro: true,
    btnImportHided: false,
    btnAvantHided: false,
    btnOptimHided: false,
    btnApresHided: false,
    btnExportHided: false,
    btnDownloadHided: false,
    btnAdminHided: false,
    viewer: false,
    sites: null,
    cooperatives: [],
  },
  getters: {
    getCooperatives(state) {
      return state.cooperatives;
    },
    onLoadToast(state) {
      return state.onLoadToast;
    },
    optimId(state) {
      return state.userInfos.optimId;
    },
    btnImportValue(state) {
      return state.userInfos.btnImport;
    },
    btnAvantValue(state) {
      return state.userInfos.btnAvant;
    },
    btnOptimValue(state) {
      return state.userInfos.btnOptim;
    },
    btnApresValue(state) {
      return state.userInfos.btnApres;
    },
    btnExportValue(state) {
      return state.userInfos.btnApres;
    },
    btnDownloadValue(state) {
      return state.userInfos.btnTemplate;
    },
    btnAdminValue() {
      return true;
    },
  },
  actions: {
    setCooperatives({ commit, state }) {
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL + process.env.VUE_APP_REF_COOPERATIVES,
        headers: {
          user: state.user,
        },
      })
        .then(res => {
          commit('SET_COOPERATIVES', res.data._embedded.datas);
        })
        .catch(() => { });
    },
    setSites({ commit, state }) {
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_SITES_COOPERATIVES_REPOSITORY +
          `/search/findByRefCooperativeIdEquals?projection=site&refCooperativeId=${state.userCoopId}`,
        headers: {
          user: state.user,
        },
      })
        .then(res => {
          commit('SET_SITES', res.data._embedded.datas.map(e => e.site));
        })
        .catch(() => { });
    },
    removeSite({ commit }, siteId) {
      commit('REMOVE_SITE', siteId);
    },
    setAllButtons(context, obj) {
      context.commit('setAllButtons', obj);
    },
    addUserInfos(context, userInfos) {
      context.commit('setUserInfos', userInfos);
    },
    removeUserInfos(context) {
      context.commit('setUserInfos', null);
    },
    addUser(context, user) {
      context.commit('setUser', user);
    },
    removeUser(context) {
      context.commit('emptyUser');
    },
    addUserId(context, userId) {
      context.commit('setUserId', userId);
    },
    removeUserId(context) {
      context.commit('emptyUserId');
    },
    addUserNames(context, userNames) {
      context.commit('setUserNames', userNames);
    },
    removeUserNames(context) {
      context.commit('emptyUserNames');
    },
    addUserCoop(context, coop) {
      context.commit('setUserCoop', coop);
    },
    removeUserCoop(context) {
      context.commit('removeUserCoop');
    },
    activateImporting(context) {
      context.commit('setImporting', true);
    },
    activateOptimizing(context) {
      context.commit('setOptimizing', true);
    },
    desactivateIntro(context) {
      context.commit('introFalse');
    },
    activateIntro(context) {
      context.commit('introTrue');
    },
    checkMoteurFalse(context) {
      context.commit('checkMoteurFalse');
    },
    checkMoteurTrue(context) {
      context.commit('checkMoteurTrue');
    },
    haveToImportFalse(context) {
      context.commit('haveToImportFalse');
    },
    haveToImportTrue(context) {
      context.commit('haveToImportTrue');
    },
    addDataSource(context, dataSource) {
      context.commit('setDataSource', dataSource);
    },
    addOptimId(context, optimId) {
      context.commit('setOptimId', optimId);
    },
    removeOptimId(context) {
      context.commit('emptyOptimId');
    },
    removeDataSource(context) {
      context.commit('emptyDataSource');
    },
    viewerFalse(context) {
      context.commit('viewerFalse');
    },
    viewerTrue(context) {
      context.commit('viewerTrue');
    },
    superAdminFalse(context) {
      context.commit('superAdminFalse');
    },
    superAdminTrue(context) {
      context.commit('superAdminTrue');
    },
    showDownloadBtn(context) {
      context.commit('activateDownloadBtn');
    },
    setButtons(context, obj) {
      context.commit('setAllButtons', obj);
    },
    hideAllButtons(context) {
      context.commit('setAllButtonsHidden');
    },
    startIntervalTimer({ state }, func) {
      state.intervalTimer = setInterval(() => func(), 5000);
    },
    stopIntervalTimer({ state }) {
      clearInterval(state.intervalTimer);
    },
    fetchUserInfos(context) {
      const url = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_USER_INFOS;
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: url,
          headers: {
            user: context.state.user,
          },
        })
          .then(res => {
            context.state.userInfos = res.data;
            context.dispatch('getCooperativeId').then(() => {
              resolve(res.data);
            });
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getCooperativeId({ state }) {
      const cooperativeUrl =
        process.env.VUE_APP_BASE_URL +
        process.env.VUE_APP_USER_REPOSITORY +
        `/${state.userInfos.id}/cooperative`;
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: cooperativeUrl,
          headers: {
            user: state.userInfos.email,
          },
        })
          .then(res => {
            state.userCoopId = res.data.id;
            state.userCoop = res.data.nom;
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      });
    },
  },
  mutations: {
    SET_COOPERATIVES(state, cooperatives) {
      state.cooperatives = cooperatives;
    },
    SET_SITES(state, sites) {
      state.sites = sites;
    },
    REMOVE_SITE(state, siteId) {
      state.sites = state.sites.filter(site => {
        return site.refSite.id !== siteId;
      });
    },
    setOnLoadToast(state, { message, type }) {
      state.onLoadToast = { message, type };
    },
    emptyOnLoadToast(state) {
      state.onLoadToast = null;
    },
    setImporting(state, value) {
      state.userInfos.importing = value;
    },
    setExporting(state, value) {
      state.userInfos.exporting = value;
    },
    setOptimizing(state, value) {
      state.userInfos.optimizing = value;
    },
    setUserInfos(state, userInfos) {
      state.userInfos = userInfos;
    },
    setUser(state, user) {
      state.user = user;
    },
    setUserId(state, userId) {
      state.userId = userId;
    },
    setUserNames(state, { firstName, lastName }) {
      state.userFirstName = firstName;
      state.userLastName = lastName;
    },
    setUserCoop(state, coop) {
      state.userCoop = coop;
    },
    emptyUser(state) {
      state.user = '';
    },
    emptyUserId(state) {
      state.userId = null;
    },
    emptyUserNames(state) {
      state.userFirstName = null;
      state.userLastName = null;
    },
    emptyUserCoop(state) {
      state.userCoop = null;
    },
    introFalse(state) {
      state.intro = false;
    },
    introTrue(state) {
      state.intro = true;
    },
    checkMoteurFalse(state) {
      state.checkMoteur = false;
    },
    checkMoteurTrue(state) {
      state.checkMoteur = true;
    },
    haveToImportFalse(state) {
      state.haveToImport = false;
    },
    haveToImportTrue(state) {
      state.haveToImport = true;
    },
    setDataSource(state, dataSource) {
      state.dataSource = dataSource;
    },
    emptyDataSource(state) {
      state.dataSource = '';
    },
    setOptimId(state, optimId) {
      state.userInfos.optimId = optimId;
    },
    emptyOptimId(state) {
      state.userInfos.optimId = null;
    },
    viewerTrue(state) {
      state.btnImportHided = true;
      state.btnDownloadHided = true;
      state.btnOptimHided = true;
      state.btnExportHided = true;
      state.btnAdminHided = true;
      state.viewer = true;
    },
    viewerFalse(state) {
      state.viewer = false;
    },
    superAdminTrue(state) {
      state.superAdmin = true;
    },
    superAdminFalse(state) {
      state.superAdmin = false;
    },
    activateDownloadBtn(state) {
      state.btnDownloadHided = false;
    },
    setAllButtons(state, o) {
      state.userInfos.btnImport = !o.hideImport;
      state.userInfos.btnAvant = !o.hideBefore;
      state.userInfos.btnOptim = !o.hideOptim;
      state.userInfos.btnApres = !o.hideAfter;
    },
    setAllButtonsHidden(state) {
      state.userInfos.btnImport = false;
      state.userInfos.btnAvant = false;
      state.userInfos.btnOptim = false;
      state.userInfos.btnApres = false;
      state.userInfos.btnTemplate = false;
    },
    setAllButtonsShown(state) {
      state.userInfos.btnImport = true;
      state.userInfos.btnAvant = true;
      state.userInfos.btnOptim = true;
      state.userInfos.btnApres = true;
      state.userInfos.btnTemplate = true;
    },
    setButtonToPreviousState(state, array) {  
      for (const [key, value] of Object.entries(state.userInfos)) {
        array.forEach(element => {
          if (key === element.cle) {
            state.userInfos[key] = element.valeur;
          }
        })
      }

    },
    getButtonStates(state, array) {
      while (array.length > 0) {
        array.pop();
      }
      const regex = /^btn/;
      for (const [key, value] of Object.entries(state.userInfos)) {
        if (regex.test(key)) {
          array.push({ cle: key, valeur: value });
        }
      }
    }
  },
});
